import MessageInputContext from './MessageInputContext';
import { withMessageInputContextProvider } from './withMessageInputContextProvider';

export default MessageInputContext;
export {
  withMessageInputContextProvider,
};
